module.exports = __webpack_public_path__ + "img/Diga.86930a9d.png";